import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import lodash from 'lodash';

import { getAppConfig } from 'common/util/configUtil';

export default function GoogleAnalytics({ history }){
    const {
        googleAnalyticsTrackingId,
        googleAnalyticsDebugMode,
        googleAnalyticsSiteSpeedSampleRate,
    } = getAppConfig();

    const debugMode = googleAnalyticsDebugMode === 'true';
    const siteSpeedSampleRate = lodash.toInteger(googleAnalyticsSiteSpeedSampleRate);

    ReactGA.initialize(googleAnalyticsTrackingId, {
        debug: debugMode,
        gaOptions: {
            siteSpeedSampleRate,
        },
    });

    history.listen(handlePageView(history));

    return null;
}

function handlePageView(history){
    let previousLocation = history.getCurrentLocation();
    ReactGA.pageview(previousLocation.pathname);

    return currentLocation => {
        handlePathnameChanges(previousLocation, currentLocation);
        handleQuerystringChanges(previousLocation, currentLocation);

        previousLocation = currentLocation;
    };
}

function handlePathnameChanges({
    pathname: previousPathname
}, {
    pathname: currentPathname,
    search: currentRawQuerystring,
}){
    if(pathnamesAreDifferent(previousPathname, currentPathname)){
        ReactGA.pageview(`${currentPathname}${currentRawQuerystring}`);
    }
}

function handleQuerystringChanges({
    pathname: previousPathname,
    query: previousQuerystring,
    search: previousRawQuerystring
}, {
    pathname: currentPathname,
    query: currentQuerystring,
    search: currentRawQuerystring
}){
    if(!pathnamesAreDifferent(previousPathname, currentPathname)
       && querystringsAreDifferent(previousQuerystring, currentQuerystring)){

        const previousSearchValue = lodash.get(previousQuerystring, 'q', '');
        const currentSearchValue = lodash.get(currentQuerystring, 'q', '');
        const searchValuesAreEqual = lodash.isEqual(previousSearchValue, currentSearchValue);

        if(searchValuesAreEqual){
            ReactGA.pageview(`${currentPathname}${currentRawQuerystring}`);
        }
        else {
            ReactGA.event({
                category: `Search: ${currentPathname}`,
                action: currentSearchValue,
            });
        }
    }
}

function pathnamesAreDifferent(previousPathname, currentPathname){
    return previousPathname !== currentPathname;
}

function querystringsAreDifferent(previousQuerystring, currentQuerystring){
    return !lodash.isEqual(previousQuerystring, currentQuerystring);
}

GoogleAnalytics.propTypes = {
    history: PropTypes.shape({
        listen: PropTypes.func,
    }).isRequired,
};

export const trackEvent = ReactGA.event;
